import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Link } from '@models';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'app-vessel-link-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
    ReactiveFormsModule,
  ],
})
export class VesselLinkFormComponent {
  isEdit = signal<boolean>(false);
  dialogRef = inject<MatDialogRef<VesselLinkFormComponent>>(MatDialogRef);

  href = new FormControl('', {validators:[Validators.required]});
  title = new FormControl('', {});
  linkForm = new FormGroup({
    href: this.href,
    title: this.title,
  });

  constructor() {
    const link = inject<Link>(MAT_DIALOG_DATA);

    this.isEdit.set(!!link);

    if (link) {
      if (link.href) {
        this.href.setValue(link.href);
      }

      if (link.title) {
        this.title.setValue(link.title);
      }
    }
  }

  submit() {
    if (this.linkForm.pristine || !this.linkForm.valid) { return };

    const data = {
      href: this.linkForm.value.href,
      title: this.linkForm.value.title ? this.linkForm.value.title : undefined,
      rel: 'related',
    } as Link;

    this.dialogRef.close(data);
  }

  cancel() {
    this.dialogRef.close();
  }
}
